import { SearchInput } from '@billy/design-system'
import { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useQuotesListFilters } from '../../../../context/quotesListFilters'

export const QuotesSearch = (): ReactElement => {
  const { t } = useTranslation()
  const [{ searchQuery }, setFilters] = useQuotesListFilters()

  const isSearchInputFocused = !!searchQuery

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setFilters({ page: 1, searchQuery: event.target.value || undefined })
    },
    [setFilters],
  )

  const handleClear = useCallback(() => {
    setFilters({ page: 1, searchQuery: undefined })
  }, [setFilters])

  return (
    <SearchInput
      focused={isSearchInputFocused}
      onChangeDebounced={handleChange}
      onClear={handleClear}
      placeholder={`${t('search')}...`}
      value={searchQuery}
    />
  )
}
